(() => {
  if (window.__lumbvHotProductCardCartBound) return;
  window.__lumbvHotProductCardCartBound = true;

  const cartUrl = () => window.routes?.cart_url || '/cart';
  const cartAddUrl = () => window.routes?.cart_add_url || '/cart/add.js';

  const setLoading = (button, loading) => {
    button.classList.toggle('loading', loading);
    button.toggleAttribute('aria-busy', loading);
    button.disabled = loading;
    if (loading) {
      button.setAttribute('aria-disabled', 'true');
    } else {
      button.removeAttribute('aria-disabled');
    }
    button.querySelector('.loading__spinner')?.classList.toggle('hidden', !loading);
  };

  const getCartSections = (cart) => {
    if (!cart || typeof cart.getSectionsToRender !== 'function') return [];
    return cart.getSectionsToRender().map((section) => section.id);
  };

  const addToCart = async (button) => {
    if (button.disabled || button.getAttribute('aria-disabled') === 'true') return;

    const form = button.closest('form');
    const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    if (!form || !cart) {
      window.location.assign(cartUrl());
      return;
    }

    const formData = new FormData(form);
    const sections = getCartSections(cart);
    if (sections.length) {
      formData.append('sections', sections);
      formData.append('sections_url', cartUrl());
      cart.setActiveElement?.(button);
    }

    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];
    config.body = formData;

    setLoading(button, true);
    cart.open?.(button);

    try {
      const response = await fetch(cartAddUrl(), config);
      const parsedState = await response.json();

      if (!response.ok || parsedState.status) {
        throw new Error(parsedState.description || parsedState.message || window.cartStrings?.error || 'Unable to add to cart.');
      }

      if (parsedState.sections && typeof cart.renderContents === 'function') {
        cart.renderContents(parsedState);
      } else {
        window.location.assign(cartUrl());
      }

      cart.classList.remove('is-empty');
    } catch (error) {
      console.error(error);
      window.location.assign(cartUrl());
    } finally {
      setLoading(button, false);
    }
  };

  document.addEventListener(
    'click',
    (event) => {
      const button = event.target.closest('.lumbv-hot-product-card__cart');
      if (!button) return;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation?.();

      addToCart(button);
    },
    true
  );
})();
